// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"d006bbfe","239":"e72afcac","355":"33d60439","389":"aa37307b","455":"7a371dff","470":"96411814","570":"3bccb30d","707":"e1c1e4da","886":"aa2ffdc4","966":"c441e6f8","977":"853f225c","994":"b6601abf"}[chunkId] + ".chunk.js";
};